import { DashboardStats } from "@billingnow/zod-schema";
import { apiClient } from "./client";

export type { DashboardStats, MonthlyData } from "@billingnow/zod-schema";

export const getDashboardStats = async (): Promise<{ stats: DashboardStats }> => {
  const response = await apiClient.get<{ stats: DashboardStats }>("/api/dashboard-stats");
  return response.data;
};
